import { isEmpty } from './isEmpty';
import { stringCompare } from './stringUtils';

export const Genders = Object.freeze({
  MALE: {
    key: 'MALE',
    value: 'M',
    displayText: 'Male'
  },
  FEMALE: {
    key: 'FEMALE',
    value: 'F',
    displayText: 'Female'
  },
  NOT_SPECIFIED: {
    key: 'NS',
    value: 'NS',
    displayText: 'Not Specified'
  }
});

export const isMale = (gender) => !isEmpty(gender) && stringCompare(Genders.MALE.key, gender.key);

export const isGenderEqual = (gender1, gender2) => {
  if (isEmpty(gender1) || isEmpty(gender2)) {
    return false;
  }
  return stringCompare(gender1.key, gender2.key);
};

export const getGenderOptions = () =>
  Object.values(Genders)
    .filter((gender) => gender.key !== Genders.NOT_SPECIFIED.key)
    .map((gender) => ({
      id: gender.key,
      text: gender.displayText,
      obj: gender
    }));

export const getGenderOptionsWithNotSpecified = () =>
  Object.values(Genders).map((gender) => ({
    id: gender.key,
    text: gender.displayText,
    obj: gender
  }));

export const getGender = (value) => getGenderOptionsWithNotSpecified().find((gender) => gender.id === value);

export const getGenderByCode = (code) => getGenderOptionsWithNotSpecified().find((gender) => gender.obj.value === code);
